import React from 'react';
import {connect} from 'react-redux';
// import { Link } from 'react-router';
import {browserHistory} from 'react-router';
import {bindActionCreators} from 'redux';
import {Row, Col} from 'react-bootstrap';
import flattenDeep from 'lodash/flattenDeep';
import uniq from 'lodash/uniq';

import StudentSteps from '../common/StudentSteps';
import * as runActions from '../../actions/runsActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as courseActions from '../../actions/coursesActionCreators';
import * as loginActions from '../../actions/loginActionCreators';
import Spinner from 'react-spinkit';
import toastr from 'toastr';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import Schedules from './schedules/Schedules';
import WeekPicker from '../common/DatePicker/WeekPicker';

class ViewSchedulesPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    BigCalendar.setLocalizer(
      BigCalendar.momentLocalizer(moment)
    );

    this.state = {
      schedulesReady: false,
      events: [],
      topks: [],
      selectedWeekDays: null
    }

    this.prepareSchedules = this.prepareSchedules.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout() {
    const isEmulating = sessionStorage.getItem('emulating')
    let runName = localStorage.getItem('run');
    this.props.loginActions.logoutAndRedirect().then(() => {
      if (isEmulating) return browserHistory.push('/administer/' + runName);
      browserHistory.push('/rank/'+runName+'/login');
    });
  }

  handleNext = () => {
    const runName = localStorage.getItem('run');
    browserHistory.push(`/rank/${runName}/confirm`);
  }

  componentWillMount() {
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }
    if (this.props.courses.length == 0) {
      this.props.courseActions.getAllCourses()
        .then(() => {
          if (!localStorage.getItem('topkTime')) {
            this.props.studentActions.topk();
          }
        });
    } else {
      if (!localStorage.getItem('topkTime')) {
        this.props.studentActions.topk();
      }
    }
    this.props.runActions.getAllRankPreferences();
    if (!this.props.student.id) {
      this.props.studentActions.getStudent()
        .then(res => {
          if (res.target_course_units == null) {
            browserHistory.push('/rank/' + localStorage.getItem('run') + '/start');
          }
        });
    }

  }


  componentDidMount() {
    if (localStorage.getItem('topkTime')) {
      let url = localStorage.getItem('topkUrl');
      this.setState({topkStatus: true});
      this.props.runActions.continueStopRun(url).then(() => {
        localStorage.removeItem('topkTime');
        localStorage.removeItem('topkUrl');
        this.setState({topkStatus: false});
      }).catch(() => {
        toastr.error('Time Out reached. Try again in few minutes.');
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.student.topks != this.props.student.topks) {
      this.prepareSchedules(nextProps.student.topks);
    }
  }

  prepareSchedules(topks) {
    let schedules = [];
    if(topks.length != 0) {
      topks.map(topk => {
        schedules.push(topk);
      });
    }
    // let schedule = topks.length != 0 ? topks[0].schedules : null;
    this.setState({schedulesReady: true});
    this.setState({topks: schedules});
  }

  getMinMaxDateFromTopkSchedule = () => {
    const { topks } = this.state;
    const { courses } = this.props;

    // get the courses given by the topk generator in a single flatten array.
    const rankedTopkCourses = topks.reduce((prev, curr) => {
      const currentCourses = flattenDeep(curr.schedules);

      return [...prev, ...currentCourses];
    }, []);

    // Delete duplicated courses and fetch the meeting dates
    const rankedTopkCoursesDates = uniq(rankedTopkCourses).reduce((prev, curr) => {
      const course = courses.find((c) => c.id === curr);
      const courseMeetingDates = course.meetings.map((c) => ([c.startdate, c.enddate]) );

      return [...prev, ...flattenDeep(courseMeetingDates)];
    }, []);


    rankedTopkCoursesDates.sort((a, b) => new Date(a) - new Date(b)); // sort metting dates asc.

    return {
      minDate: rankedTopkCoursesDates[0],
      maxDate: rankedTopkCoursesDates[rankedTopkCoursesDates.length - 1]
    }
  }

  handleSelectWeek = (weekDays) => {
    this.setState({ selectedWeekDays: weekDays });
  }

  renderLoadingSpinner = () => (
    <div className="spinner-box">
      <Spinner spinnerName="three-bounce" className="mt-4" />
    </div>
  );

  renderPageSubtitle = () => (
    <Col md={9}>
      <div className="page-subtitle mt-0">Review your potential schedules</div>
    </Col>
  )

  renderNextButton = () => (
    <Col md={3}>
      {/* COMMENTED OUT IN CASE WE NEED IT IN THE FUTURE

        let runName = localStorage.getItem('run'); ARRANGE THIS LINE
        <Link
          to={'/rank/'+runName+'/rank'}
          className="btn btn-ter mb-2 pull-left">Re-Rank Classes
        </Link>
  
      */}
      <button
        onClick={this.handleNext}
        className="pull-right btn btn-width-auto btn-primary"
      >
        Next: Confirm
      </button>
    </Col>
  );

  renderInstructionText = () => {
    const { run } = this.props;

    if (run.additional_view_schedules != null) {
      return (
        <p className="lead" dangerouslySetInnerHTML={{
            __html: this.props.run.additional_view_schedules
              .replace('[[[primary_contact_email]]]',
                `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`)
          }}>
        </p>
      )
    }

    return '';
  }

  render() {
    const { schedulesReady, topks, selectedWeekDays } = this.state;
    const { minDate, maxDate } = this.getMinMaxDateFromTopkSchedule();

    return (
      <div>
        <Row>
          <Col md={12}>
            {this.props.run.id && this.props.student.id ?
              <div>
                {this.props.run.id ?
                  <StudentSteps active={3} />
                  : null}
                {schedulesReady && (
                  <Row>
                    {this.renderPageSubtitle()}
                    {this.renderNextButton()}
                  </Row>
                )}
                <Row className="mb-4">
                  <Col md={9}>
                    {schedulesReady && this.renderInstructionText()}
                  </Col>
                </Row>
                { schedulesReady && (
                  <Row>
                    <Col md={3} mdOffset={9}>
                      <WeekPicker
                        handleSelectWeek={this.handleSelectWeek}
                        minDate={minDate}
                        maxDate={maxDate}
                        inputClassNames="week-picker-auto-width"
                      />
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={12} className="height-auto">
                    {schedulesReady ? <Schedules topks={topks} filteredDays={selectedWeekDays} /> : this.renderLoadingSpinner()}
                  </Col>
                </Row>
              </div>

              : <div className="spinner-box">
              <Spinner spinnerName="three-bounce" className="mt-4"/>
            </div>}

          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    courseActions: bindActionCreators(courseActions, dispatch),
    loginActions: bindActionCreators(loginActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewSchedulesPage);



// WEBPACK FOOTER //
// ./src/components/rank/ViewSchedulesPage.js